import { hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { resolveGeoRoute, geoRouteHead } from "@/lib/geoRouteSeo";
import NotFound from "@/pages/NotFound";
import TownServiceDetail from "@/pages/TownServiceDetail";
import { getApprovedTownContent } from "@/lib/townContent.functions";

export const Route = createFileRoute("/_public/locations/$stateSlug/$townSlug/$serviceSlug")({
  loader: async ({ params }) => {
    if (!resolveGeoRoute([params.stateSlug, params.townSlug, params.serviceSlug])) throw notFound();
    try {
      const content = await getApprovedTownContent({
        data: {
          stateSlug: params.stateSlug,
          townSlug: params.townSlug,
          serviceSlug: params.serviceSlug,
        },
      });
      return { content };
    } catch {
      return { content: null };
    }
  },
  component: TownServicePage,
  head: ({ params, loaderData, matches }) => geoRouteHead([params.stateSlug, params.townSlug, params.serviceSlug], Boolean(loaderData) && !hasUnavailableMatch(matches)),
  notFoundComponent: NotFound,
  errorComponent: NotFound,
});

function TownServicePage() {
  const { content } = Route.useLoaderData();
  return <TownServiceDetail content={content} />;
}
